<template>
  <div class="body-box marginBox2">
    <el-row class="plan" style="margin-bottom: 10px;"></el-row>
    <el-form
      ref="addFormRef"
      :model="addForm"
      :rules="rules"
      label-width="140px"
      style="padding: 20px;background-color: #fff;"
    >
      <el-row>
        <!--标题-->
        <el-col :span="8">
          <el-form-item label="旅行标题" prop="title">
            <el-input v-model="addForm.title" placeholder="请输入标题" />
          </el-form-item>
        </el-col>

        <!--排序-->
        <el-col :span="8">
          <el-form-item label="排序" prop="resort">
            <el-input v-model="addForm.resort" placeholder="请输入排序" />
          </el-form-item>
        </el-col>

        <!--假期价格-->
<!--        <el-col :span="8" class="label">-->
<!--          <el-form-item label="单人间假期价格">-->
<!--            <el-input v-model="addForm.fees[0].blueTeePrice" placeholder="请输入单人间假期价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

        <!--平时价格-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="单人间平时价格" class="label">-->
<!--            <el-input v-model="addForm.fees[0].costPrice" placeholder="请输入单人间平时价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

        <!--平日+休日-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="平日+休日价格" class="label">-->
<!--            <el-input v-model="addForm.fees[0].weekHolidayPrice" placeholder="请输入单人间平日+休日价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

        <!--假期价格-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="双人间假期价格" class="label">-->
<!--            <el-input v-model="addForm.fees[1].blueTeePrice" placeholder="请输入双人间假期价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

        <!--平时价格-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="双人间平时价格" class="label">-->
<!--            <el-input v-model="addForm.fees[1].costPrice" placeholder="请输入双人间平时价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <!--平日+休日-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="平日+休日价格" class="label">-->
<!--            <el-input v-model="addForm.fees[1].weekHolidayPrice" placeholder="请输入双人间平日+休日价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

        <el-col :span="8">
          <el-form-item label="选择旅行区域" prop="addr.areaId">
            <!--<area-tree v-model="addForm.addr.areaId" @change="getVal"></area-tree>-->
            <trip-zone v-model="addForm.addr.areaId" @change="getVal"></trip-zone>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="旅行地址" prop="addr.addr">
            <el-input v-model="addForm.addr.addr" placeholder="请输入地址" @change="changeAddr" />
          </el-form-item>
        </el-col>

        <!--选择球场-->
        <el-col :span="8">
          <el-form-item label="选择球场">
            <el-select v-model="addForm.btCourtId" clearable placeholder="请选择球场" style="width: 100%">
              <el-option v-for="item in byAreaIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="价格" prop="price">
            <el-input type="textarea" v-model="addForm.price" placeholder="请输入价格" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="旅行轮播图" prop="carousel">
            <thumbnail-list v-model="addForm.carousel" :autoCropWidth="800" :autoCropHeight="500"
                            :fixedNumber="[16,10]"></thumbnail-list>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="旅行缩略图" prop="thumbnail">
            <thumbnail v-model="addForm.thumbnail" :autoCropWidth="800" :autoCropHeight="500"
                       :fixedNumber="[16,10]"></thumbnail>
          </el-form-item>
        </el-col>

        <!--酒店名称-->
        <el-col :span="24" v-for="(item, index) in hotelList" :key="index">
          <el-form-item :label="'酒店名称' + (index + 1)">
            <el-input v-model="item.hotel" placeholder="请输入酒店名称" style="width: 24.17%" />
            <span v-if="index === 0" @click="addHotel(index + 1)" class="el-icon-circle-plus-outline"
                  style="margin-left: 10px;font-size: 18px"></span>
            <span v-if="index !== 0" @click="subHotel(item)" class="el-icon-remove-outline"
                  style="margin-left: 10px;font-size: 18px"></span>
          </el-form-item>
          <!--选择区域-->
          <!-- <el-form-item label="选择区域" style="width: 33.5%">
             <area-tree v-model="item.areaId" @change="getVal"></area-tree>
           </el-form-item>-->
          <el-form-item label="地址" style="width: 33.5%">
            <el-input v-model="item.addr" placeholder="请输入地址" @change="changeAddr" />
          </el-form-item>
          <el-form-item label="电话号码" style="width: 33.5%">
            <el-input v-model="item.tel" placeholder="请输入电话号码"/>
          </el-form-item>
          <el-form-item label="轮播图" prop="carousel">
            <thumbnail-list v-model="item.carousel" :autoCropWidth="800" :autoCropHeight="500"
                            :fixedNumber="[16,10]"></thumbnail-list>
          </el-form-item>
          <el-col :span="24">
            <el-form-item label="缩略图" prop="thumbnail">
              <thumbnail v-model="item.thumbnail" :autoCropWidth="800" :autoCropHeight="500"
                         :fixedNumber="[16,10]"></thumbnail>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="介绍" class="el-form-item-label">
              <el-input type="textarea" v-model="item.remarks" placeholder="请输入介绍" />
            </el-form-item>
          </el-col>

        </el-col>
        <el-col :span="24">
          <el-form-item label="费用说明" prop="costDescription">
            <el-input type="textarea" v-model="addForm.costDescription" placeholder="请输入费用说明" />
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="时间表" prop="timetable">
            <el-input type="textarea" v-model="addForm.timetable" placeholder="请输入时间表" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="旅行介绍">
            <el-input type="textarea" v-model="addForm.remarks" placeholder="请输入介绍" />
          </el-form-item>
        </el-col>




        <!--预约规定-->
<!--        <el-col :span="24">-->
<!--          <el-form-item label="预约规定">-->
<!--            <el-input type="textarea" v-model="addForm.atRules" placeholder="请输入预约规定" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
      </el-row>

    </el-form>

    <div class="goBackBox">
      <el-button @click="goBack">返 回</el-button>
      <el-button @click="addTravel">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { addTravel, getByAreaId } from '@/api/travel/travel'
import { getData } from '@/utils/code'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import { getLngLatByAddr } from '@/api/court/court'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import TripZone from '@/components/common/tripZone/tripZone'
import { travelRules } from '@/js/rules'

export default {
  components: { TripZone, ThumbnailList, Thumbnail },
  name: 'addTravel',
  data() {
    return {
      hotelList: [
        {
          id: '',
          hotel: '',
          addr: '',
          remarks: '',
          carousel: '',
          thumbnail: ''
        }
      ],
      addForm: {
        // fees: [
        //   {
        //     blueTeePrice: '',
        //     costPrice: '',
        //     weekHolidayPrice: '',
        //     enumType: 'TRAVEL_SINGLE'
        //   }, {
        //     blueTeePrice: '',
        //     costPrice: '',
        //     weekHolidayPrice: '',
        //     enumType: 'TRAVEL_DOUBLE'
        //   }
        // ],
        price: '',
        addr: {
          enumType: 'TRAVEL'
        }
      },
      rules: travelRules,
      byAreaIdList: []
    }
  },
  methods: {
    //缩略图
    getMd5(arr) {
      this.addForm.thumbnail = arr.md5
    },

    getVal(val) {
      getByAreaId(val).then(res => {
        this.byAreaIdList = res.data
      })
    },

    //查询经纬度
    changeAddr() {
      const val = {
        addr: this.addForm.addr.addr
      }
      getLngLatByAddr(val).then(res => {
        if (res.code === '0') {
          this.addForm.addr.lat = res.data.lat
          this.addForm.addr.lng = res.data.lng
        } else {
          this.addForm.addr.lat = ""
          this.addForm.addr.lng = ""
          this.$message.error('地址查询失败,请填写详细地址')
        }
      })
    },

    // 添加
    addTravel() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        let flag = true
        // this.addForm.fees.forEach(f => {
        //   if (!f.blueTeePrice || !f.costPrice) {
        //     return flag = false
        //   }
        // })
        // 判断地址是否正确
        if (this.addForm.addr.lat === "" || this.addForm.addr.lng === "") {
          this.$message.error('请填写正确的地址！');
          return
        }
        if (flag && this.addForm.thumbnail && this.addForm.carousel && this.hotelList) {
          this.addForm.hotelInfo = JSON.stringify(this.hotelList)
          addTravel(this.addForm).then((response) => {
            let data = getData(response)
            if (data !== null) {
              this.$router.go(-1)
            }
          })
        } else {
          this.$message.error('请完善信息')
        }

      })
    },

    //返回上一级
    goBack() {
      this.$router.go(-1)
    },

    //添加一个酒店
    addHotel(index) {
      const obj = {
        id: index,
        hotel: '',
        addr: '',
        remarks: '',
        carousel: '',
        thumbnail: ''
      }
      this.hotelList.push(obj)
    },

    //删除一个
    subHotel(item) {
      this.hotelList.remove(item)
    }

  }
}
</script>

<style scoped lang="less">
/deep/ .el-input {
  width: 90%;
}

/deep/ .shuttle_bus {
  position: relative;

  .location_box {
    position: absolute;
    top: 8px;
    right: 10px;
  }
}

/deep/ .el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
</style>
